import React from 'react'
import { Footer } from '../components/common/Footer/Footer'
import { Navigate, Outlet } from 'react-router-dom';
import { useLocation } from "react-router-dom";

export const PublicLayout = () => {


//? Posible buena idea, redirigir a /biblioteca si el usuario ya inicio sesion para no mostrar el login nuevamente 

const getStatus = localStorage.getItem('authStatus')
//console.log('authStatus: ', getStatus)

const location = useLocation() //👉 Obtiene la ruta actual

//console.log("Ruta actual: ", location.pathname) //👉 Muestra la ruta actual

if (getStatus === 'authorized' && (location.pathname === '/' || location.pathname === '/login')) {

  return <Navigate to="/biblioteca" />
}

  return (
    <>


      <Outlet /> {/* 👉 Renderiza las rutas hijas (Login, Register, etc)*/}

     
      <Footer />
    </>
  )
}

